<template><div class="cart"><van-nav-bar title="购物车" fixed /><div v-if="cartTotalNum>0&&token"><div class="cart-title"><span class="all">共<i>{{cartTotalNum}}</i>件商品</span><span class="edit" @click="toggleEdit"><van-icon name="edit"/>{{isEdit?'完成':'编辑'}}</span></div><div class="cart-list"><div class="cart-item" v-for="item in cartList" :key="item.id"><van-checkbox :value="item.isChecked" @click="handlecheck(item.id)"/><div class="show" @click="$router.push(`/prodetail/${item.goods_id}`)"><img :src="item.goods.goods_image"/></div><div class="info"><span class="tit text-ellipsis-2">{{item.goods.goods_name}}</span><span class="bottom"><div class="price">¥<span>{{item.goods.goods_price_min}}</span></div><div class="count-box"><CountBox :value="item.goods_num" @input="v=>handleCount(item.goods_id,item.goods_sku_id,v)"/></div></span></div></div></div><div class="footer-fixed"><div class="all-check"><van-checkbox :icon-size="18" :value="checkAllState" @click="isAll"/>全选</div><div class="all-total"><div class="price"><span>合计：</span><span>¥<i class="totalPrice">{{selGoodsTotalPrice}}</i></span></div><div v-if="!isEdit" class="goPay" :class="{disabled:selGoodsNum==0}" @click="goPay">结算({{selGoodsNum}})</div><div v-else class="delete" :class="{disabled:selGoodsNum==0}" @click="deleteGoods">删除({{selGoodsNum}})</div></div></div></div><div v-else class="empty-cart"><img src="https://img.yzcdn.cn/vant/empty-image-default.png"/><p class="tips">购物车是空的</p><span class="btn" @click="$router.push('/home')">去逛逛</span></div></div></template>
<template>
  <div class="cart">
    <van-nav-bar title="购物车" fixed />

    <div v-if="cartTotalNum > 0 && token">
      <div class="cart-title">
        <span class="all">共<i>{{ cartTotalNum }}</i>件商品</span>
        <span class="edit" @click="toggleEdit">
          <van-icon name="edit" /> {{ isEdit ? '完成' : '编辑' }} 
        </span>
      </div>

      <div class="cart-list">
        <div class="cart-item" v-for="item in cartList" :key="item.id">
          <van-checkbox :value="item.isChecked" @click="handlecheck(item.id)" />
          <div class="show" @click="$router.push(`/prodetail/${item.goods_id}`)">
            <img :src="item.goods.goods_image" alt="">
          </div>
          <div class="info">
            <span class="tit text-ellipsis-2">{{ item.goods.goods_name }}</span>
            <span class="spec-text" v-if="item.spec_text">{{ item.spec_text }}</span>
            <span class="bottom">
              <div class="price">¥ <span>{{ item.goods.goods_price_min }}</span></div>
              <div class="count-box">
                <CountBox :value="item.goods_num" @input="value => handleCount(item.goods_id, item.goods_sku_id, value)" />
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="footer-fixed">
        <div class="all-check">
          <van-checkbox :icon-size="18" :value="checkAllState" @click="isAll" /> 全选 
        </div>
        <div class="all-total">
          <div class="price">
            <span>合计：</span>
            <span>¥ <i class="totalPrice">{{ selGoodsTotalPrice }}</i></span>
          </div>
          <div v-if="!isEdit" class="goPay" :class="{ disabled: selGoodsNum == 0 }" @click="goPay">结算({{ selGoodsNum }})</div>
          <div v-else class="delete" :class="{ disabled: selGoodsNum == 0 }" @click="deleteGoods">删除({{ selGoodsNum }})</div>
        </div>
      </div>
    </div>

    <div v-else class="empty-cart">
      <img src="https://img.yzcdn.cn/vant/empty-image-default.png" alt="">
      <p class="tips">购物车是空的，去逛逛吧~</p>
      <span class="btn" @click="$router.push('/home')">去逛逛</span>
    </div>
  </div>
</template>

<script>
import CountBox from '@/components/CountBox.vue'
export default {
  name: 'Cart',
  components: { CountBox },
  data () { return { isEdit: false } },
  computed: {
    token () { return this.$store.getters.token },
    cartList () { return this.$store.state.cart.cartList },
    cartTotalNum () { return this.$store.getters['cart/cartGoodsTotal'] },
    checkAllState () { return this.cartList.every(item => item.isChecked) },
    selGoodsTotalPrice () { return this.$store.getters['cart/selGoodsTotalPrice'] },
    selGoodsNum () { return this.$store.getters['cart/selGoodsNum'] }
  },
  created () { if (this.token) { this.$store.dispatch('cart/getCartList') } },
  methods: {
    toggleEdit () { this.isEdit = !this.isEdit },
    handlecheck (id) { this.$store.commit('cart/changeSelGood', id) },
    handleCount (goodsId, goodsSkuId, value) { this.$store.dispatch('cart/updateCartGoodsInfo', { goodsId, goodsNum: value, goodsSkuId }) },
    isAll () { this.$store.commit('cart/isAll', !this.checkAllState) },
    deleteGoods () { if (this.selGoodsNum === 0) return; this.$store.dispatch('cart/deleteCartGoods') },
    goPay () {
      if (this.selGoodsNum === 0) return
      const cartIds = this.$store.getters['cart/selGoods'].map(item => item.id)
      this.$router.push({ path: '/pay', query: { mode: 'cart', cartIds: cartIds.join(',') } })
    }
  }
}
</script>

<style lang="less" scoped>
.cart { padding-top: 46px; padding-bottom: 100px; background-color: #f5f5f5; min-height: 100vh;
  .cart-title { height: 40px; display: flex; justify-content: space-between; align-items: center; padding: 0 10px; font-size: 14px;
    .all i { font-style: normal; margin: 0 2px; color: #ff6b35; font-size: 16px; }
    .edit .van-icon { font-size: 18px; }
  }
  .cart-item { margin: 0 10px 10px 10px; padding: 10px; display: flex; justify-content: space-between; background-color: #fff; border-radius: 5px;
    .show img { width: 100px; height: 100px; }
    .info { width: 210px; padding: 10px 5px; font-size: 14px; display: flex; flex-direction: column; justify-content: space-between;
      .spec-text { font-size: 12px; color: #999; background: #f7f8fa; display: inline-block; padding: 1px 6px; border-radius: 4px; align-self: flex-start; }
      .bottom { display: flex; justify-content: space-between; align-items: center;
        .price { display: flex; align-items: flex-end; color: #ff6b35; font-size: 12px; span { font-size: 16px; } }
      }
    }
  }
  .footer-fixed { position: fixed; left: 0; bottom: 50px; height: 50px; width: 100%; border-bottom: 1px solid #ccc; background-color: #fff; display: flex; justify-content: space-between; align-items: center; padding: 0 10px;
    .all-check { display: flex; align-items: center; .van-checkbox { margin-right: 5px; } }
    .all-total { display: flex; align-items: center; line-height: 36px;
      .price { font-size: 14px; margin-right: 10px; .totalPrice { color: #ff6b35; font-size: 18px; font-style: normal; } }
      .delete, .goPay { min-width: 100px; height: 36px; line-height: 36px; text-align: center; background-color: #ff6b35; color: #fff; border-radius: 18px;
        &.disabled { background-color: #ff9779; }
      }
    }
  }
  .empty-cart { padding: 80px 30px;
    img { width: 140px; height: 92px; display: block; margin: 0 auto; }
    .tips { text-align: center; color: #666; margin: 30px; }
    .btn { width: 110px; height: 32px; line-height: 32px; text-align: center; background-color: #ff6b35; border-radius: 16px; color: #fff; display: block; margin: 0 auto; }
  }
}
</style>
